import { SVGProps, Ref, forwardRef } from 'react';

export const ItAccreditationSize24Glyph = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
        <path d="M17.717 22v-9.913H20.5v-3.13h-2.783V3.739h-3.13v5.218h-2.783v3.13h2.783V22z" fill="currentColor" />
        <path d="M9.413 8.957H3.5v3.13h2.783V22h3.13z" fill="currentColor" />
        <path d="M7.848 6.348a2.174 2.174 0 1 0 0-4.348 2.174 2.174 0 0 0 0 4.348" fill="currentColor" />
    </svg>
));
ItAccreditationSize24Glyph.displayName = 'ItAccreditationSize24Glyph';
